import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class PayButtonModel extends ButtonBase {
    label: string = 'Pay';
    action: string = ACTION_STATUS.pay;
    matIconName: string = 'account_balance_wallet';
    colorClass: string = 'color-success-500';
}